module.exports = __webpack_public_path__ + "static/img/Informed Decision-Making.d01d8370.webp";